import { useContext, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Alert from '../../components/Alert';
import { OrderContext } from '../../store/OrderProvider';
import { PaymentMethod } from '../../models/types';
import Field from '../../components/Field';
import { RepositoryContext } from '../../store/RepositoryProvider';
import API from '../../server/api';
import Account from '../../models/account/Account';
import Subdivision from '../../models/subdivision/Subdivision';
import { UserContext } from '../../store/UserProvider';

const StepPaymentBooking = () => {
  const {t} = useTranslation(['common', 'order']);

  const repository = useContext(RepositoryContext);
  const orderInfo = useContext(OrderContext);
  const userInfo = useContext(UserContext);

  const [paymentMethod, setPaymentMethod] = orderInfo.useSession('payment_method', PaymentMethod.ONLINE);
  const [sessionSubdivision] = userInfo.useSession('subdivision');

  const [paymentErrors] = orderInfo.useState('payment_errors', []);

  const [account, setAccount] = useState(null);
  const [subdivision, setSubdivision] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const handleCloseError = useCallback((uid) => {
    orderInfo.clearError('payment_booking', uid);
  }, []);


  useEffect(() => {
    let methods = Object.values(PaymentMethod);

    if (subdivision && subdivision.disabledPaymentMethods instanceof Array) {
      subdivision.disabledPaymentMethods.forEach((m) => {
        methods = methods.filter((method) => method !== m);
      });
    }

    if (account && account.payments) {
      if (!account.payments.online) {
        methods = methods.filter((method) => method !== PaymentMethod.ONLINE);
      }
      if (!account.payments.card) {
        methods = methods.filter((method) => method !== PaymentMethod.CARD && method !== PaymentMethod.QRCODE);
      }
    }

    setPaymentMethods(methods);
    if (methods.indexOf(paymentMethod) === -1 && methods.length > 0) {
      setPaymentMethod(methods[0]);
    }
  }, [subdivision, account]);
  
  
  useEffect(() => {
    repository.request(API.account.account, {}, Account).then((a) => {
      setAccount(a);
    }).catch(() => {
      setAccount(null);
    });

    repository.request(API.subdivision.subdivision, {id: sessionSubdivision}, Subdivision).then((s) => {
      setSubdivision(s);
    }).catch(() => {
      setSubdivision(null);
    });
  }, []);

  return (
    <>
      <div>
        {paymentErrors.map((error, i) => (
          <Alert type={error.type} key={error.uid} title={error.title} dismissible={true} onClose={() => handleCloseError(error.uid)}>{error.message}</Alert>
        ))}
        <Field title={t('order:payment_booking.payment_method')}>
          {paymentMethods.indexOf(PaymentMethod.CASH) >= 0 && (
            <div className={ `payment-method icon-${PaymentMethod.CASH}` } onClick={() => setPaymentMethod(PaymentMethod.CASH)}>{t(`order:payment_booking.${PaymentMethod.CASH}`)}{paymentMethod === PaymentMethod.CASH && (<span className="payment-current">{t('order:payment_booking.current')}</span>)}</div>
          )}
          {paymentMethods.indexOf(PaymentMethod.ONLINE) >= 0 && (
            <div className={ `payment-method icon-${PaymentMethod.ONLINE}` } onClick={() => setPaymentMethod(PaymentMethod.ONLINE)}>{t(`order:payment_booking.${PaymentMethod.ONLINE}`)}{paymentMethod === PaymentMethod.ONLINE && (<span className="payment-current">{t('order:payment_booking.current')}</span>)}</div>
          )}
          {paymentMethods.indexOf(PaymentMethod.QRCODE) >= 0 && (
            <div className={ `payment-method icon-${PaymentMethod.QRCODE}` } onClick={() => setPaymentMethod(PaymentMethod.QRCODE)}>{t(`order:payment_booking.${PaymentMethod.QRCODE}`)}{paymentMethod === PaymentMethod.QRCODE && (<span className="payment-current">{t('order:payment_booking.current')}</span>)}</div>
          )}
          {paymentMethods.indexOf(PaymentMethod.CARD) >= 0 && (
            <div className={ `payment-method icon-${PaymentMethod.CARD}` } onClick={() => setPaymentMethod(PaymentMethod.CARD)}>{t(`order:payment_booking.${PaymentMethod.CARD}`)}{paymentMethod === PaymentMethod.CARD && (<span className="payment-current">{t('order:payment_booking.current')}</span>)}</div>
          )}
        </Field>
      </div>
    </>
  )
}

StepPaymentBooking.propTypes = {
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
  onError: PropTypes.func,
};

export default StepPaymentBooking;